import { FETCH_USER_FAIL, FETCH_USER_START, FETCH_USER_SUCCEED } from '../actions/user';

interface UserState {
  items: Record<string, App.User>;
  isLoading: boolean;
  isUpdating: boolean;
  error?: unknown;
}

type UserAction =
  | { type: typeof FETCH_USER_START }
  | { type: typeof FETCH_USER_SUCCEED; user: App.User }
  | { type: typeof FETCH_USER_FAIL; error: unknown };

const initialState: UserState = { items: {}, isLoading: true, isUpdating: false };

export default function userReducer(state: UserState = initialState, action: UserAction): UserState {
  switch (action.type) {
    case FETCH_USER_START: {
      const newState = { ...state };
      delete newState.error;
      return {
        ...newState,
        isLoading: true,
      };
    }
    case FETCH_USER_SUCCEED: {
      return {
        ...state,
        isLoading: false,
        items: Object.assign({}, state.items, {
          [action.user.memberId]: action.user,
        }),
      };
    }
    case FETCH_USER_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
}
